module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-welcome-page"
  }, [(_vm.$root.userEmail) ? _c('div', {
    staticClass: "sk-welcome-user"
  }, [_c('span', {
    staticClass: "sk-user-initials"
  }, [_vm._v(_vm._s(_vm.userInitials))]), _vm._v(" "), _c('span', {
    staticClass: "sk-user-email"
  }, [_vm._v(_vm._s(_vm.$root.userEmail))]), _vm._v(" "), _c('button', {
    staticClass: "sk-welcome-logout",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-welcome-main"
  }, [_c('div', {
    staticClass: "sk-welcome-card"
  }, [(_vm.effectivelyComplete) ? _c('div', {
    staticClass: "sk-sync-complete-banner"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#16a34a",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Sync complete")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.syncCompleteSubtext))])])]) : _c('div', {
    staticClass: "sk-welcome-header"
  }, [_c('h1', [_vm._v("Setting up your workspace…")]), _vm._v(" "), _c('p', [_vm._v("Syncing your Amazon catalog and setting up real-time Buy Box monitoring. Takes 2–5 minutes for most accounts.")])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "sk-error-msg"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-checklist"
  }, _vm._l((_vm.derivedSteps), function(step, i) {
    return _c('div', {
      key: step.id,
      staticClass: "sk-check-item",
      class: {
        done: step.completed
      }
    }, [_c('div', {
      staticClass: "sk-check-icon"
    }, [(step.completed) ? _c('svg', {
      attrs: {
        "viewBox": "0 0 20 20",
        "fill": "#16a34a"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
        "clip-rule": "evenodd"
      }
    })]) : (step.inProgress) ? _c('div', {
      staticClass: "sk-check-spinner-wrap"
    }, [_c('div', {
      staticClass: "sk-check-spinner"
    })]) : _c('div', {
      staticClass: "sk-check-pending"
    })]), _vm._v(" "), (i < _vm.derivedSteps.length - 1) ? _c('div', {
      staticClass: "sk-check-line"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sk-check-label"
    }, [_vm._v(_vm._s(step.completed ? step.completedLabel : step.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sk-progress-bar-wrap"
  }, [_c('span', {
    staticClass: "sk-progress-left"
  }, [_vm._v(_vm._s(_vm.effectivelyComplete ? 'All done' : 'Sync in progress'))]), _vm._v(" "), _c('span', {
    staticClass: "sk-progress-right",
    class: {
      done: _vm.effectivelyComplete
    }
  }, [_vm._v(_vm._s(_vm.progressPercent) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-progress-bar"
  }, [_c('div', {
    staticClass: "sk-progress-fill",
    class: {
      done: _vm.effectivelyComplete
    },
    style: ({
      width: _vm.progressPercent + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "sk-progress-label"
  }, [_vm._v(_vm._s(_vm.completedSteps) + " of " + _vm._s(_vm.totalSteps) + " steps complete")]), _vm._v(" "), (_vm.effectivelyComplete) ? _c('button', {
    staticClass: "sk-btn sk-btn-done",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]), _vm._v("\n        Your dashboard is ready — Go to Dashboard\n      ")]) : _c('button', {
    staticClass: "sk-btn sk-btn-progress",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]), _vm._v("\n        Go to Dashboard\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "sk-footer-text"
  }, [_vm._v(_vm._s(_vm.effectivelyComplete ? "From tomorrow, you'll land directly on your dashboard." : 'Sync continues in the background. Your dashboard will update automatically as data comes in.'))]), _vm._v(" "), _c('p', {
    staticClass: "sk-footer-text sk-regions-hint"
  }, [_vm._v("Selling in more regions? Add them from "), _c('router-link', {
    attrs: {
      "to": "/settings/sellers"
    }
  }, [_vm._v("Settings → Sellers")]), _vm._v(".")], 1), _vm._v(" "), (!_vm.effectivelyComplete) ? _c('p', {
    staticClass: "sk-skip-row"
  }, [_c('button', {
    staticClass: "sk-skip-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.skipConnectForNow
    }
  }, [_vm._v("\n          Skip for now — connect Amazon later\n        ")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c161ef2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/WelcomePage.vue
// module id = 787
// module chunks = 2